exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".popsale-ad {\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(121, 206, 197, 0.54);\n  z-index: 99999;\n}\n.popsale-ad .popsale-ad__content {\n  text-align: center;\n  display: block;\n}\n.popsale-ad .popsale-ad__content img {\n  position: absolute;\n  max-width: 70%;\n  max-height: 70vh;\n  height: auto;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n  cursor: pointer;\n}\n.popsale-ad .popsale-ad-dismiss .material-icons {\n  position: absolute;\n  top: 20px;\n  right: 20px;\n  color: white;\n}", ""]);

// exports
